import React, {useEffect, useState} from "react";
import {withRouter,Redirect} from "react-router";
import {FormControl, withStyles, InputLabel, FormHelperText,RadioGroup,Radio,FormControlLabel} from "@material-ui/core";
import {withTranslation} from "react-i18next";
import clsx from "clsx";
import Avatar from "@material-ui/core/Avatar";
import {
    AccountBalanceRounded,
    AccountBoxRounded,
    AccountCircleRounded, AccountTreeRounded, EmailRounded,
    LockRounded, PersonPinCircle, PersonPinRounded, PersonRounded, PersonSharp,
    SecurityRounded,
    VisibilityOffRounded,
    VisibilityRounded
} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import * as colors from "../../constants/colors";
import {useDispatch, useSelector} from "react-redux";
import * as links from "../../constants/links";
import AppDatePicker from "../../themes/components/AppDatePicker";
import moment from "moment-timezone";
import {register} from "../../sagas/auth/actions";
import {Link} from "react-router-dom";
import {
    COUNTRY_FR,
    PERSON_CATEGORY_ADULT,
    PERSON_CATEGORY_CHILD,
    PERSON_CATEGORY_TEACHER
} from "../../constants/params";
import AppCountryAutocomplete from "../../themes/components/AppCountryAutocomplete";
import AppRegionAutocomplete from "../../themes/components/AppRegionAutocomplete";

const styles = (theme)=>({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: "#ffd02f",
        minHeight: 600,
        borderRadius: 6,
        position: "relative",
        width: "100%",
        maxWidth: 480,
        marginLeft: "auto",
        marginRight: "auto"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.primary.main,
    },
    form: {
        width: '100%',
        marginTop: "1rem",
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        minHeight: "3.5rem"
    },
    formContainer:{
        marginTop: "2rem",
        borderRadius: 6,
        padding: "2rem 1rem",
        border: "1px solid #00000026"
    },
    textField:{
        color: colors.DARK_COLOR,
        "& fieldset":{
            color: colors.DARK_COLOR
        },
        "& input,& label,& legend span,& label.Mui-focused":{
            color: colors.DARK_COLOR
        },
        "& $notchedOutline":{
            borderColor:colors.DARK_COLOR
        },
        "&.Mui-focused,& .MuiOutlinedInput-root":{
            background:"#fff",
        },
        "& .MuiOutlinedInput-input,& button.MuiIconButton-root, & .MuiSelect-icon":{
            color: colors.TEXT_PRIMARY_COLOR
        }

    },
    birthOfDate:{

    },
    selectContainer:{
        "& fieldset>legend":{
            maxWidth: 1000
        }
    },
    loginBtn:{
        color: colors.DARK_COLOR,
        display: "block",
        textAlign: "center",
        fontSize: "1.2rem"
    },
    categoryContainer:{
        background: colors.PRIMARY_WHITE,
        borderRadius: 6,
        marginLeft: 3,
        marginRight: 4,
        "& .MuiFormGroup-root":{
            padding: "7px 14px"
        },
        "& .MuiRadio-root:not(.Mui-checked)":{
            color: colors.TEXT_PRIMARY_COLOR
        }
    }
});
function Register(props){
    const {classes,t,history} = props;
    const [username,setUsername] = useState("");
    const [firstName,setFirstName] = useState("");
    const [lastName,setLastName] = useState("");
    //const [dateOfBirth,setDateOfBirth] = useState(null);
    const [nickname,setNickName] = useState("");
    //const [gender,setGender] = useState("");
    const [yearOfBirth,setYearOfBirth] = useState(null);
    const [category,setCategory] = useState("");
    const [department,setDepartment] = useState(null);
    const [country,setCountry] = useState(null);
    const [password,setPassword] = useState("");
    const [showPassword,setShowPassword] = useState(false);
    const {authenticated,error,loading} = useSelector((state)=>state.authState);
    const routing = useSelector((state)=>state.router);
    const dispatch = useDispatch();
    const [nextUrlAfterRegister,setNextUrlAfterRegister] = useState(null);
    const formRef = React.useRef();
    const [formErrors,setFormErrors] = React.useState({});
    useEffect(()=>{
        if (typeof error === "object"){
            setFormErrors({...error});
        }
    },[error])
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (username===""){
            formErrors.username = t("text.error.form.required_field")
        }
        else if (formErrors.hasOwnProperty("username")){
            delete formErrors.username;
        }
        // if (firstName===""){
        //     formErrors["firstName"] = t("text.error.form.required_field");
        // }
        // if (lastName===""){
        //     formErrors["lastName"] = t("text.error.form.required_field");
        // }
        if (password===""){
            formErrors.password = t("text.error.form.required_field");
        }
        else if (formErrors.hasOwnProperty("password")){
            delete formErrors.password;
        }
        if (category===PERSON_CATEGORY_ADULT && yearOfBirth===null){
            formErrors.yearOfBirth = t("text.error.form.required_field");
        }
        if (nickname===""){
            formErrors.nickname = t("text.error.form.required_field");
        }
        else if (formErrors.hasOwnProperty("nickname")){
            delete formErrors.nickname;
        }
        if (category===""){
            formErrors.category = t("text.error.form.required_field");
        }
        else if (formErrors.hasOwnProperty("category")){
            delete formErrors.category;
        }
        if (country===null){
            formErrors.country = t("text.error.form.required_field");
            if (formErrors.hasOwnProperty("department")){
                delete formErrors.department;
            }
        }
        else{
            if (formErrors.hasOwnProperty("country")){
                delete formErrors.country;
            }
            if (country===COUNTRY_FR){
                if (department===null){
                    formErrors.department = t("text.error.form.required_field");
                }
                else if (formErrors.hasOwnProperty("department")){
                    delete formErrors.department;
                }
            }
        }
        // if (dateOfBirth===null){
        //     formErrors["dateOfBirth"] = t("text.error.form.required_field");
        // }
        // else if (moment.isMoment(dateOfBirth) && !dateOfBirth.isValid()){
        //     formErrors["dateOfBirth"] = t("text.error.form.date.invalid");
        // }
        // if (gender === ""){
        //     formErrors["gender"] = t("text.error.form.required_field")
        // }
        console.log(formErrors);
        setFormErrors({...formErrors});
        if (Object.keys(formErrors).length===0){
            registerUser();
        }
    }
    const checkErrorOnChange = (field,value,event)=>{
        if (value!=="" && value!==null && formErrors.hasOwnProperty(field) && (!event || event.target.checkValidity())){
            delete formErrors[field];
            setFormErrors({...formErrors});
        }
    }
    const registerUser = (auto=false)=>{
        let nextUrlAfterRegister;
        if (routing && routing.location && routing.location.state && routing.location.state.from && routing.location.state.from.pathname && routing.location.state.from.pathname!==links.LOGIN){
            nextUrlAfterRegister = routing.location.state.from.pathname;
            setNextUrlAfterRegister(nextUrlAfterRegister);
        }
        let birthYear = null;
        if (moment.isMoment(yearOfBirth) && yearOfBirth.isValid()){
            birthYear = yearOfBirth.format('YYYY');
        }
        console.log(birthYear);
        dispatch(register({
            username,
            password,
            firstName,
            lastName,
            category,
            nickname,
            yearOfBirth:birthYear,
            country,
            department,
            // gender: gender,
            // dateOfBirth: moment.isMoment(dateOfBirth) && dateOfBirth.isValid()?dateOfBirth.format("YYYY-MM-DD"):null,
            nextUrlAfterRegister: nextUrlAfterRegister
        }));
    }
    if (authenticated){
        return <Redirect to={{pathname:links.HOME,nextUrl:nextUrlAfterRegister}}/>
    }
    return <Grid item xs={12} sm={12} md={5} lg={4} className={clsx(classes.loginBlock,classes.paper)}>
        <Avatar className={classes.avatar}>
            <LockRounded style={{color: "white"}} />
        </Avatar>
        <Typography component="h1" variant="h3" className={classes.connectionTitle}>
            {t("label.registration")}
        </Typography>
        <Container maxWidth={"sm"} className={classes.formContainer}>
            <form ref={formRef} className={classes.form} method={"POST"} onSubmit={(e)=>handleSubmit(e)}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                inputProps={
                                    {
                                        form:{
                                            autoComplete: false
                                        }
                                    }
                                }
                                InputProps={{
                                    required:true,
                                    startAdornment: <InputAdornment position="start">
                                        <AccountCircleRounded />
                                    </InputAdornment>
                                }}
                                error={!!formErrors && !!formErrors.lastName}
                                helperText={!!formErrors && !!formErrors.lastName?t(formErrors.lastName):null}
                                name="lastName"
                                variant="outlined"
                                fullWidth
                                id="lastName"
                                label={t("label.lastName")}
                                value={lastName}
                                onChange={(e)=>{
                                    setLastName(e.target.value);
                                    checkErrorOnChange("lastName",e.target.value,e);
                                }}
                                className={clsx(classes.textField)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                inputProps={
                                    {
                                        form:{
                                            autoComplete: false
                                        }
                                    }
                                }
                                InputProps={{
                                    required:true,
                                    startAdornment: <InputAdornment position="start">
                                        <AccountCircleRounded />
                                    </InputAdornment>
                                }}
                                error={!!formErrors && !!formErrors.firstName}
                                helperText={!!formErrors && !!formErrors.firstName?t(formErrors.firstName):null}
                                name="firstName"
                                variant="outlined"
                                fullWidth
                                id="firstName"
                                label={t("label.firstName")}
                                value={firstName}
                                onChange={(e)=>{
                                    setFirstName(e.target.value);
                                    checkErrorOnChange("firstName",e.target.value,e);

                                }}
                                className={clsx(classes.textField)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                inputProps={
                                    {
                                        form:{
                                            autoComplete: false
                                        }
                                    }
                                }
                                InputProps={{
                                    required:true,
                                    startAdornment: <InputAdornment position="start">
                                        <EmailRounded />
                                    </InputAdornment>
                                }}
                                autoComplete={false}
                                error={!!formErrors && !!formErrors.username}
                                helperText={!!formErrors && !!formErrors.username?t(formErrors.username):null}
                                name="username"
                                variant="outlined"
                                fullWidth
                                type={"email"}
                                id="username"
                                required
                                label={t("label.email")}
                                value={username}
                                onChange={(e)=>{
                                    setUsername(e.target.value);
                                    checkErrorOnChange("username",e.target.value,e);
                                    if (e.target.value!=="" && !e.target.checkValidity()){
                                        formErrors["username"] = t("text.error.form.email.invalid");
                                        setFormErrors({...formErrors});
                                    }
                                }}
                                className={clsx(classes.textField)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="password"
                                required
                                error={!!formErrors && !!formErrors.password}
                                helperText={!!formErrors && !!formErrors.password?t(formErrors.password):null}
                                label={t("label.password")}
                                type={showPassword?"text":"password"}
                                id="password"
                                value={password}
                                autoComplete={false}
                                onChange={(e)=>{
                                    setPassword(e.target.value);
                                    checkErrorOnChange("password",e.target.value,e);
                                }}
                                inputProps={
                                    {
                                        form:{
                                            autoComplete: false
                                        }
                                    }
                                }
                                InputProps={{
                                    required:true,
                                    startAdornment: <InputAdornment position="start">
                                        <SecurityRounded />
                                    </InputAdornment>,
                                    endAdornment: <InputAdornment className={classes.passwordVisibilityIcon} onClick={()=>{
                                        setShowPassword(!showPassword);
                                    }} position="end">
                                        {showPassword?<VisibilityRounded/>:<VisibilityOffRounded/>}
                                    </InputAdornment>
                                }}
                                className={clsx(classes.textField)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                name="nickname"
                                required
                                error={!!formErrors && !!formErrors.nickname}
                                helperText={!!formErrors && !!formErrors.nickname?t(formErrors.nickname):null}
                                label={t("label.nickname")}
                                id="nickname"
                                value={nickname}
                                autoComplete={false}
                                onChange={(e)=>{
                                    setNickName(e.target.value);
                                    checkErrorOnChange("nickname",e.target.value,e);
                                }}
                                inputProps={
                                    {
                                        form:{
                                            autoComplete: false
                                        }
                                    }
                                }
                                InputProps={{
                                    required:true,
                                    startAdornment: <InputAdornment position="start">
                                        <AccountCircleRounded />
                                    </InputAdornment>,
                                }}
                                className={clsx(classes.textField)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} className={classes.categoryContainer}>
                            <FormControl error={!!formErrors && !!formErrors.category} variant="outlined" className={classes.textField+" "+classes.selectContainer} fullWidth>
                                <InputLabel required shrink>{t("label.category")}</InputLabel>
                                <RadioGroup label
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            defaultValue="None"
                                            value={category}
                                            onChange={(e)=>{
                                                setCategory(e.target.value);
                                                checkErrorOnChange("category",e.target.value);
                                            }}
                                >
                                    <FormControlLabel value={PERSON_CATEGORY_TEACHER} control={<Radio color="primary" />} label={t("label.category_teacher")} />
                                    <FormControlLabel value={PERSON_CATEGORY_CHILD} control={<Radio color="primary" />} label={t("label.category_child")} />
                                    <FormControlLabel value={PERSON_CATEGORY_ADULT} control={<Radio color="primary" />} label={t("label.category_adult")} />
                                    <FormControlLabel value={"None"} control={<Radio color="primary" />} label={t("label.category_other")} />
                                </RadioGroup>
                                {/*<Select*/}
                                {/*    fullWidth*/}
                                {/*    placeholder={t("label.select")}*/}
                                {/*    value={category}*/}
                                {/*    label={t("label.category")}*/}
                                {/*    onChange={(e)=>{*/}
                                {/*        setCategory(e.target.value);*/}
                                {/*        checkErrorOnChange("category",e.target.value);*/}
                                {/*    }}*/}
                                {/*    inputProps={*/}
                                {/*        {*/}
                                {/*            required:true,*/}
                                {/*            placeholder: t("label.select"),*/}
                                {/*            form:{*/}
                                {/*                autoComplete: false*/}
                                {/*            }*/}
                                {/*        }*/}
                                {/*    }*/}
                                {/*    required*/}
                                {/*>*/}
                                {/*    <MenuItem value={PERSON_CATEGORY_TEACHER}>{t("label.category_teacher")}</MenuItem>*/}
                                {/*    <MenuItem value={PERSON_CATEGORY_CHILD}>{t("label.category_child")}</MenuItem>*/}
                                {/*    <MenuItem value={PERSON_CATEGORY_ADULT}>{t("label.category_adult")}</MenuItem>*/}
                                {/*    <MenuItem value={"None"}>{t("label.category_other")}</MenuItem>*/}
                                {/*</Select>*/}
                                {!!formErrors && !!formErrors.category && <FormHelperText>{formErrors.category}</FormHelperText>}
                            </FormControl>
                        </Grid>
                    </Grid>
                    {category === PERSON_CATEGORY_ADULT && <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <FormControl variant="outlined" className={classes.textField+ " "+classes.birthOfDate} fullWidth>
                                <AppDatePicker
                                    onChange={(date,value)=>{
                                        setYearOfBirth(date);
                                        checkErrorOnChange("yearOfBirth",date);
                                        if (date!==null && !date.isValid()){
                                            formErrors["yearOfBirth"] = t("text.error.form.date.invalid");
                                            setFormErrors({...formErrors});
                                        }
                                    }}
                                    variant={"inline"}
                                    format={"YYYY"}
                                    openTo={"year"}
                                    views={["year"]}
                                    disableToolbar={true}
                                    showTodayButton={false}
                                    maxDate={moment().subtract(18,"years")}
                                    inputProps={
                                        {
                                            placeholder: t("label.yyyy"),
                                            form:{
                                                autoComplete: false
                                            }
                                        }
                                    }
                                    TextFieldProps={{
                                        variant: "outlined",
                                        InputLabelProps:{
                                            shrink: true
                                        },
                                        error:!!formErrors && !!formErrors.yearOfBirth,
                                        helperText:!!formErrors && !!formErrors.yearOfBirth?t(formErrors.yearOfBirth):null,
                                        type: "date"
                                    }}
                                    label={t("label.year_of_birth")}
                                    disableFuture
                                    value={yearOfBirth}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>}
                    <Grid item container xs={12} spacing={1}>
                        <Grid item xs={12} sm={6}>
                            <FormControl error={!!formErrors && !!formErrors.country} variant="outlined" className={classes.textField+" "+classes.selectContainer} fullWidth>
                                <InputLabel required shrink>{t("label.country")}</InputLabel>
                                <AppCountryAutocomplete
                                    inputPlaceHolder={""}
                                    disableClearable
                                    required
                                    onChange={(e,value)=>{
                                        setCountry(!!value?value.code.toUpperCase():"");
                                        checkErrorOnChange("country",!!value?value.code.toUpperCase():"",e);
                                    }}
                                    defaultValue={COUNTRY_FR}
                                    value={country}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {country === COUNTRY_FR && <FormControl error={!!formErrors && !!formErrors.department} variant="outlined" className={classes.textField+" "+classes.selectContainer} fullWidth>
                                <InputLabel required shrink>{t("label.department")}</InputLabel>
                                <AppRegionAutocomplete
                                    inputPlaceHolder={""}
                                    disableClearable
                                    required
                                    onChange={(e,value)=>{
                                        console.log(value);
                                        setDepartment(!!value?value.code.toString().toUpperCase():"");
                                        checkErrorOnChange("department",!!value?value.code.toString().toUpperCase():"",e);
                                    }}
                                    value={department}
                                />
                            </FormControl>}
                        </Grid>
                    </Grid>

                    {/*<Grid item container xs={12} spacing={1}>*/}
                    {/*    <Grid item xs={12} sm={6}>*/}
                    {/*        <FormControl variant="outlined" className={classes.textField+ " "+classes.birthOfDate} fullWidth>*/}
                    {/*            <AppDatePicker*/}
                    {/*                onChange={(date,value)=>{*/}
                    {/*                    setDateOfBirth(date);*/}
                    {/*                    checkErrorOnChange("dateOfBirth",date);*/}
                    {/*                    if (date!==null && !date.isValid()){*/}
                    {/*                        formErrors["dateOfBirth"] = t("text.error.form.date.invalid");*/}
                    {/*                        setFormErrors({...formErrors});*/}
                    {/*                    }*/}
                    {/*                }}*/}
                    {/*                inputProps={*/}
                    {/*                    {*/}
                    {/*                        placeholder: t("label.dd_mm_yyyy"),*/}
                    {/*                        form:{*/}
                    {/*                            autoComplete: false*/}
                    {/*                        }*/}
                    {/*                    }*/}
                    {/*                }*/}
                    {/*                TextFieldProps={{*/}
                    {/*                    variant: "outlined",*/}
                    {/*                    InputLabelProps:{*/}
                    {/*                        shrink: true*/}
                    {/*                    },*/}
                    {/*                    error:!!formErrors && !!formErrors.dateOfBirth,*/}
                    {/*                    helperText:!!formErrors && !!formErrors.dateOfBirth?t(formErrors.dateOfBirth):null,*/}
                    {/*                    type: "date"*/}
                    {/*                }}*/}
                    {/*                label={t("label.date_of_birth")}*/}
                    {/*                disableFuture*/}
                    {/*                value={dateOfBirth}*/}
                    {/*                required*/}
                    {/*            />*/}
                    {/*        </FormControl>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid item xs={12} sm={6}>*/}
                    {/*        <FormControl error={!!formErrors && !!formErrors.gender} variant="outlined" className={classes.textField+" "+classes.genderContainer} fullWidth>*/}
                    {/*            <InputLabel required shrink>{t("label.gender")}</InputLabel>*/}
                    {/*            <Select*/}
                    {/*                fullWidth*/}
                    {/*                id="gender"*/}
                    {/*                placeholder={t("label.select")}*/}
                    {/*                value={gender}*/}
                    {/*                label={t("label.gender")}*/}
                    {/*                onChange={(e)=>{*/}
                    {/*                    setGender(e.target.value);*/}
                    {/*                    checkErrorOnChange("gender",e.target.value);*/}
                    {/*                }}*/}
                    {/*                inputProps={*/}
                    {/*                    {*/}
                    {/*                        placeholder: t("label.select"),*/}
                    {/*                        form:{*/}
                    {/*                            autoComplete: false*/}
                    {/*                        }*/}
                    {/*                    }*/}
                    {/*                }*/}
                    {/*                defaultValue={""}*/}
                    {/*                required*/}
                    {/*            >*/}
                    {/*                <MenuItem value={"M"}>{t("label.gender_male")}</MenuItem>*/}
                    {/*                <MenuItem value={"F"}>{t("label.gender_female")}</MenuItem>*/}
                    {/*                <MenuItem value={"None"}>{t("label.gender_other")}</MenuItem>*/}
                    {/*            </Select>*/}
                    {/*            {!!formErrors && !!formErrors.gender && <FormHelperText>{formErrors.gender}</FormHelperText>}*/}
                    {/*        </FormControl>*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                </Grid>
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    size={"large"}
                    onClick={(e)=>{
                        if (!!loading){
                            e.preventDefault();
                        }
                    }}
                >
                    {loading && <CircularProgress className={classes.loadingLogin} size={"2rem"} color={"secondary"}/>} {t("label.register")}
                </Button>
            </form>
            <Link class={classes.loginBtn} to={links.LOGIN}>{t("label.login")}</Link>
        </Container>
    </Grid>;
}

export default withRouter(withStyles(styles)(withTranslation()(Register)));